import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import IntlMessages from "util/intlMessages";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";

const PageTitle = ({ title, className, breadCrumb }) => {
  const renderTitle = () => {
    if (typeof title === "string" && /\s/.test(title)) {
      return title;
    }
    return <IntlMessages id={title} />;
  };

  const renderCrumb = name => {
    if (typeof name === "string" && /\s/.test(name)) {
      return name;
    }
    return <IntlMessages id={name} />;
  };

  return (
    <Fragment>
      <div className="new-page-title">
        <div className={classNames("Page-title", className)}>
          <div className="title flex-1">{renderTitle()}</div>
        </div>
        {breadCrumb && (
          <div className="gt-breadcrumb-scroll">
            <Breadcrumb className="custom-breadcumb">
              {breadCrumb.map((e, i) => {
                const isLast = i === breadCrumb.length - 1;
                const label = renderCrumb(e.name);

                if (isLast) {
                  return (
                    <BreadcrumbItem key={i} active>
                      {label}
                    </BreadcrumbItem>
                  );
                }

                return (
                  <BreadcrumbItem className="breadcumb-color" key={i}>
                    {e.path ? (
                      <Link to={e.path} className="gt-breadcrumb-link">
                        {label}
                      </Link>
                    ) : (
                      label
                    )}
                  </BreadcrumbItem>
                );
              })}
            </Breadcrumb>
          </div>
        )}
      </div>
    </Fragment>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.storeID
  };
};

export default connect(mapStateToProps, null)(PageTitle);
